// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3kdN0","label":"SetPasswdForm_label__22gDT"};